import React, { useState, useEffect, useMemo } from "react";
import GetInTouchFooter from "./GetInTouchFooter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Footer from "./Footer";
import {
  FaInstagram,
  FaLinkedinIn,
  FaFacebook,
  FaWhatsapp,
} from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import axiosStrapiInstance, { prodUrl } from "../axiosStrapi";
import ReactMarkdown from "react-markdown";
import { RiShareForwardLine } from "react-icons/ri";
import { baseUrl } from "../axiosStrapi";
import moment from "moment";
import CustomGalleryModal from "./custom/CustomGalleryModal";
import rightArrowImg from "../assets/rightarrow.png";
import leftArrowImg from "../assets/leftarrow.png";
import Loader from "./custom/Loader";
import ShareModal from "./custom/ShareModal";
import { Helmet } from "react-helmet";

const BlogDetail = () => {
  const { id } = useParams();
  const [blogDetail, setBlogDetail] = useState([]);
  const [restBlogs, setMoreBlogs] = useState([]);
  const [loading, setLoading] = useState([]);
  const [shareModal, setShareModal] = useState(false);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    centerMode: true,
    centerPadding: "0px",
    nextArrow: (
      <div>
        <img className="custom-arrow" src={rightArrowImg} alt="Next" />
      </div>
    ),
    prevArrow: (
      <div>
        <img className="custom-arrow" src={leftArrowImg} alt="Previous" />
      </div>
    ),
  };

  const fetchSingleBlogData = async () => {
    try {
      setLoading(true);
      const response = await axiosStrapiInstance.get(
        `/api/blogs/${id}?populate[headerImages][populate]=*&populate[newsImages][populate]=*`
      );
      setBlogDetail(response?.data?.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data from Strapi:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosStrapiInstance.get(
          "/api/blogs?populate[headerImages][populate]=*&sort[createdAt]=desc"
        );
        const result = response?.data?.data?.filter(
          (item) => item.documentId !== id
        );
        setMoreBlogs(result.slice(0, 3) || []);
      } catch (error) {
        console.error("Error fetching data from Strapi:", error);
      }
    };
    fetchSingleBlogData();
    fetchData();
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 20);
  }, []);

  const imageData = useMemo(() => {
    if (restBlogs && blogDetail) {
      const image = window.innerWidth < 450 ? blogDetail?.headerImages?.mobileDesktopImage?.url : window.innerWidth < 800 ? blogDetail?.headerImages?.tabHeaderImage?.url : blogDetail?.headerImages?.desktopHeaderImage;
      return image?.url || blogDetail?.headerImages?.desktopHeaderImage?.url; //if no image then desktop image is the final image
    }
  }, [restBlogs, blogDetail])


  return (
    <div
      style={{
        lineHeight: "1.6",
        padding: "4% 6%",
      }}
      className="font-Lato"
    >
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <Helmet>
            <link rel="canonical" href={`https://www.motherspridepreschool.com/blog/${blogDetail?.title?.replaceAll(" ","-")}/${blogDetail?.documentId}`} />
            <title>{blogDetail?.title}</title>
            <meta
              name="description"
              content={`${blogDetail?.metaDescription}`}
            />
            <meta
              name="keywords"
              content={`${blogDetail?.metaKeywords}`}
            />
          </Helmet>
          <div className="flex flex-row text-sm mb-5 font-semibold leading-4 text-[#464646] font-Lato">
            <p className="pr-2 w-fit border-r border-[#FFC6C6]">
              {blogDetail?.readTimeInMins} Mins Read
            </p>
            <p className="pl-2">
              {moment(blogDetail?.publishedAt).format("DD/MM/YYYY")}
            </p>
          </div>
          <h1 className="text-4xl font-bold mb-[30px]">{blogDetail.title}</h1>
          <div className="flex gap-3">
            <FaInstagram
              onClick={() =>
                window.open(
                  "https://www.instagram.com/motherspridepreschool/",
                  "_blank",
                  "noopener",
                  "noreferrer"
                )
              }
              className="h-[2.5rem] w-[2.5rem] text-white text-center rounded-full p-[6px] bg-[#FF8787] cursor-pointer"
            />
            <FaLinkedinIn
              onClick={() =>
                window.open(
                  " https://www.linkedin.com/company/mothers-pride-preschool/",
                  "_blank",
                  "noopener",
                  "noreferrer"
                )
              }
              className="h-[2.5rem] w-[2.5rem] text-white text-center rounded-full p-[6px] bg-[#FF8787] cursor-pointer" />
            <FaFacebook
              onClick={() =>
                window.open(
                  "https://www.facebook.com/mothersprideonline/",
                  "_blank",
                  "noopener",
                  "noreferrer"
                )
              }
              className="h-[2.5rem] w-[2.5rem] text-white text-center rounded-full p-[6px] bg-[#FF8787] cursor-pointer"
            />
            <FaWhatsapp

              onClick={() =>
                window.open(
                  `https://wa.me/?text=Mother's%20Pride%20Blog%3A%0A ${prodUrl}/blog/${blogDetail?.title?.replaceAll(" ", "-")}/${blogDetail?.documentId}`,
                  "_blank",
                  "noopener",
                  "noreferrer"
                )
              }
              className="h-[2.5rem] w-[2.5rem] text-white text-center rounded-full p-[6px] bg-[#FF8787] cursor-pointer" />
            <button
              onClick={() => setShareModal(true)}
              className="border border-[#ff8787] px-[16px] py-2 rounded-xl text-[#FF8787] font-Lato text-[16px] leading-4">
              Share <RiShareForwardLine className="inline h-[20px] w-[20px] " />{" "}
            </button>
          </div>
          <img
            src={imageData}
            alt={blogDetail.title}
            className="rounded-[10px] w-full  lg:my-[20px] my-[2rem] h-[220px] sm:h-[350px] lg:h-[500px]"
          />
        </div>
      )}
      <div className="flex lg:flex-row mt-10 font-Lato flex-col gap-5">
        <div className="lg:flex-[2.3]">
          {blogDetail?.description && (
            <div>
              <h1 className="font-Lato font-bold text-[40px] leading-[48px] text-black">
                Introduction
              </h1>
              <p className="font-Lato my-2 text-base leading-6 font-normal text-[#383838] ">
                {blogDetail?.description}
              </p>
            </div>
          )}

          <ReactMarkdown className="blogMarkdown font-Lato">
            {blogDetail?.content}
          </ReactMarkdown>
          {blogDetail?.Type === "News" && (
            <div className=" gap-5 max-h-[700px] overflow-y-scroll mx-auto grid lg:grid-cols-2 sm:grid-cols-2 grid-cols-1 items-center justify-center mt-[60px]">
              {blogDetail?.newsImages?.map((item, index) => (
                <img
                  src={`${item?.url}`}
                  alt={`image-${index}`}
                  key={index}
                  className="rounded-lg h-[260px] w-[320px] sm:w-[420px]"
                />
              ))}
            </div>
          )}
        </div>
        <div className="flex-1 lg:ml-[50px]">
          <h3 className="text-[#D31C4F] text-3xl font-bold">
            More Blogs & News{" "}
            <img src="blogimg.png" className="inline h-[40px]" alt="" />{" "}
          </h3>
          <div
            style={{
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              marginTop: "20px",
              border: "1px solid #E3E3E3",
            }}
          >
            {restBlogs.map((blog, index) => (
              <div
                key={index}
                style={{
                  margin: "16px 8px",
                  backgroundColor: "#fff",
                  paddingBottom: "10px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  borderBottom:
                    index !== restBlogs?.length - 1 && "1px solid #E3E3E3",
                }}
                className="flex lg:items-center gap-[10px] justify-between"
              >
                <img
                  src={blog?.headerImages?.smallContainerImage ? `${blog?.headerImages?.smallContainerImage?.url}` : `${blog?.headerImages?.desktopHeaderImage?.url}`}
                  alt={blog.title}
                  style={{
                    width: "140px",
                    height: "110px",
                    borderRadius: "4px",
                    objectFit: "cover",
                  }}
                />
                <div className="flex flex-col items-end text-lg">
                  <a
                    href={`/blog/${blog?.title?.replaceAll(" ","-")}/${blog?.documentId}`}
                    style={{
                      color: "#333",
                      textDecoration: "none",
                      fontWeight: "bold",
                      height: "100%",
                      width: "100%",
                      fontSize: "16px",
                      leading: "26px",
                    }}
                  >
                    {blog.title}
                  </a>

                  <a
                    href={`/blog/${blog?.title?.replaceAll(" ","-")}/${blog?.documentId}`}
                    className="text-[#D31C4F] font-Lato font-semibold text-[16px] leading-5 cursor-pointer"
                  >
                    {" "}
                    Read More <FaArrowRight className="inline" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <GetInTouchFooter marginX={"0%"} />
      <Footer marginX={"0%"} />
      {
        shareModal && (
          <ShareModal
            onClose={()=>setShareModal(false)}
            shareUrl={`${prodUrl}blog/${blogDetail?.title?.replaceAll(" ","-")}/${blogDetail?.documentId}`}
          />
        )
      }
    </div>
  );
};

export default BlogDetail;
